import { StyleSheet, Text, View } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  footer: {
    position: "absolute",
    bottom: 10,
    left: 0,
    paddingHorizontal: 35,
    right: 0,
    fontSize: 10,
    color: "grey",
  },
  line: {
    borderBottomWidth: 1,
    borderBottomColor: "grey",
    marginBottom: 10,
  },
});

export const Footer = ({
  footerText,
  versionText,
}: {
  footerText: string;
  versionText: string;
}) => (
  <View fixed style={styles.footer}>
    <View style={styles.line} />

    <Text>{footerText}</Text>
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <Text>{versionText}</Text>
      <Text
        render={({ pageNumber, totalPages }) =>
          `strona ${pageNumber} / ${totalPages}`
        }
      />
    </View>
  </View>
);
